module.exports = __webpack_public_path__ + "img/permission-denied.11b249b0.jpg";